
// import { useState } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation, Autoplay } from "swiper/modules";

// import "swiper/css";
// import "swiper/css/navigation";

// import poojaData from "../../data/poojaData";
// import ProductCard from "../RudrakshaSection/ProductCard";

// const banners = [
//     "https://i.pinimg.com/736x/83/82/8c/83828cefbb6ae75ee2abe91d33870811.jpg",
//     "https://i.pinimg.com/736x/1a/30/ad/1a30add00515ec98c34126dfd4e2dd98.jpg",
//     "https://i.pinimg.com/736x/5e/1d/17/5e1d17e0731d8a0faa780732b3a7f872.jpg",
// ];
// export default function TulsiSection() {

//     const tabs = Object.keys(poojaData);
//     const [activeTab, setActiveTab] = useState(tabs[0]);

//     return (

//         <section className="rudraksha-section">

//             <div className="container">

//                 <div className="section-top">

//                     <h2>Buy Premium Pooja Essentials</h2>
//                     <div className="tabs">

//                         {tabs.map((tab) => (

//                             <button
//                                 key={tab}
//                                 className={activeTab === tab ? "active" : ""}
//                                 onClick={() => setActiveTab(tab)}
//                             >
//                                 {tab}
//                             </button>

//                         ))}

//                     </div>

//                 </div>

//                 <div className="section-content">

//                     <div className="left-banner">

//                         <Swiper
//                             modules={[Autoplay]}
//                             autoplay={{
//                                 delay: 3000,
//                                 disableOnInteraction: false,
//                             }}
//                             loop
//                         >
//                             {banners.map((img, index) => (
//                                 <SwiperSlide key={index}>
//                                     <img src={img} alt="" />
//                                 </SwiperSlide>
//                             ))}
//                         </Swiper>

//                     </div>

//                     <div className="right-products">

//                         <Swiper
//               modules={[Navigation, Autoplay]}
//               navigation
//               loop={true}
//               spaceBetween={10}
//               slidesPerView={3}
//               breakpoints={{
//                 0: {
//                   slidesPerView: 2,
//                   spaceBetween: 10,
//                 },
//                 576: {
//                   slidesPerView: 2,
//                   spaceBetween: 12,
//                 },
//                 768: {
//                   slidesPerView: 2,
//                   spaceBetween: 15,
//                 },
//                 1200: {
//                   slidesPerView: 3,
//                   spaceBetween: 20,
//                 },
//               }}
//             >
//                             {poojaData[activeTab].map((product) => (
//                                 <SwiperSlide key={product.id}>
//                                     <ProductCard product={product} />
//                                 </SwiperSlide>
//                             ))}

//                         </Swiper>

//                     </div>

//                 </div>

//             </div>

//         </section>
//     );
// }


// api integrated


import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import ProductCard from "../RudrakshaSection/ProductCard";
import Loader from "../Loader/Loader";
import { getProducts } from "../../api/productApi";
import { getCategories } from "../../api/getCategories";
import API_BASE_URL from "../../config";
const POOJA_CATEGORY_SLUG = "pooja";
const banners = [
  "https://i.pinimg.com/736x/83/82/8c/83828cefbb6ae75ee2abe91d33870811.jpg",
  "https://i.pinimg.com/736x/1a/30/ad/1a30add00515ec98c34126dfd4e2dd98.jpg",
  "https://i.pinimg.com/736x/5e/1d/17/5e1d17e0731d8a0faa780732b3a7f872.jpg",
];

export default function PoojaSection() {
  const [poojaCategory, setPoojaCategory] =
    useState(null);

  const [subcategories, setSubcategories] =
    useState([]);

  const [activeSubcategory, setActiveSubcategory] =
    useState(null);

  const [products, setProducts] =
    useState([]);

  const [loadingCategories, setLoadingCategories] =
    useState(true);

  const [loadingProducts, setLoadingProducts] =
    useState(false);

  useEffect(() => {

    const fetchPoojaCategory = async () => {

      try {

        setLoadingCategories(true);

        // GET ALL CATEGORIES
        const result = await getCategories();

        console.log(
          "All Categories:",
          result
        );

        if (!result?.success) {

          setPoojaCategory(null);
          setSubcategories([]);

          return;
        }

        const categories =
          result?.data || [];

  
        const pooja = categories.find(
          (category) =>
            category?.slug?.toLowerCase() ===
            POOJA_CATEGORY_SLUG.toLowerCase()
        );

        console.log(
          "Pooja Category:",
          pooja
        );

        if (!pooja) {

          console.error(
            "Pooja category not found"
          );

          setPoojaCategory(null);
          setSubcategories([]);

          return;
        }

        setPoojaCategory(pooja);

    
        if (
          Array.isArray(
            pooja.subcategories
          )
        ) {

          setSubcategories(
            pooja.subcategories
          );

        } else {

  
          const subResponse =
            await fetch(
              `${API_BASE_URL}/categories/${pooja.id}/subcategories`
            );

          const subResult =
            await subResponse.json();

          console.log(
            "Pooja Subcategories:",
            subResult
          );

          if (subResult?.success) {

            setSubcategories(
              subResult.data || []
            );

          } else {

            setSubcategories([]);

          }
        }

      } catch (error) {

        console.error(
          "Pooja Category API Error:",
          error
        );

        setPoojaCategory(null);
        setSubcategories([]);

      } finally {

        setLoadingCategories(false);

      }

    };

    fetchPoojaCategory();

  }, []);


  const fetchAllProducts = async (
    categoryId
  ) => {

    try {

      if (!categoryId) return;

      setLoadingProducts(true);

      const result = await getProducts({

        categoryId: categoryId,

        page: 1,

        limit: 12,

      });

      console.log(
        "All Pooja Products:",
        result
      );

      if (result?.success) {

        setProducts(
          result?.data?.products || []
        );

      } else {

        setProducts([]);

      }

    } catch (error) {

      console.error(
        "Pooja Products API Error:",
        error
      );

      setProducts([]);

    } finally {

      setLoadingProducts(false);

    }

  };

  const fetchProductsBySubcategory = async (
    subcategoryId
  ) => {

    try {

      if (
        !poojaCategory?.id ||
        !subcategoryId
      ) {

        return;
      }

      setLoadingProducts(true);

      const result = await getProducts({

        categoryId:
          poojaCategory.id,

        subcategoryId:
          subcategoryId,

        page: 1,

        limit: 12,

      });

      console.log(
        "Pooja Products By Subcategory:",
        result
      );

      if (result?.success) {

        setProducts(
          result?.data?.products || []
        );

      } else {

        setProducts([]);

      }

    } catch (error) {

      console.error(
        "Pooja Subcategory Products API Error:",
        error
      );

      setProducts([]);

    } finally {

      setLoadingProducts(false);

    }

  };


  useEffect(() => {

    if (poojaCategory?.id) {

      setActiveSubcategory(null);

      fetchAllProducts(
        poojaCategory.id
      );

    }

  }, [poojaCategory]);


  const handleSubcategoryClick = (
    subcategory
  ) => {

    if (!subcategory?.id) return;

    setActiveSubcategory(
      subcategory.id
    );

    fetchProductsBySubcategory(
      subcategory.id
    );

  };

  const handleAllClick = () => {

    if (!poojaCategory?.id) return;

    setActiveSubcategory(null);

    fetchAllProducts(
      poojaCategory.id
    );

  };


  return (

    <section className="rudraksha-section">

      <div className="container">


        <div className="section-top">

          <h2>
            Buy Premium Pooja Essentials
          </h2>

          <div className="tabs">

            {/* ALL POOJA */}

            <button
              type="button"
              className={
                activeSubcategory === null
                  ? "active"
                  : ""
              }
              onClick={handleAllClick}
              disabled={
                loadingCategories ||
                !poojaCategory
              }
            >
              All Pooja
            </button>

            {/* API SUBCATEGORIES */}

            {!loadingCategories &&
              subcategories.map(
                (subcategory) => (

                  <button
                    type="button"
                    key={subcategory.id}
                    className={
                      activeSubcategory ===
                      subcategory.id
                        ? "active"
                        : ""
                    }
                    onClick={() =>
                      handleSubcategoryClick(
                        subcategory
                      )
                    }
                  >
                    {subcategory.name}
                  </button>

                )
              )}

          </div>

        </div>


        <div className="section-content">


          <div className="left-banner">

            <Swiper
              modules={[Autoplay]}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              loop
            >

              {banners.map(
                (image, index) => (

                  <SwiperSlide
                    key={index}
                  >

                    <img
                      src={image}
                      alt="Pooja Essentials"
                    />

                  </SwiperSlide>

                )
              )}

            </Swiper>

          </div>


          <div className="right-products">

            {/* LOADING */}

            {loadingCategories ||
            loadingProducts ? (

              <div className="loading">
                <Loader label="Loading Pooja essentials..." size={56} />
              </div>

            ) : products.length === 0 ? (

              <div className="loading">
                No Pooja products found
              </div>

            ) : (

              <Swiper
                modules={[
                  Navigation,
                  Autoplay,
                ]}
                navigation
                loop={
                  products.length > 3
                }
                spaceBetween={10}
                slidesPerView={3}
                breakpoints={{

                  0: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },

                  576: {
                    slidesPerView: 2,
                    spaceBetween: 12,
                  },

                  768: {
                    slidesPerView: 2,
                    spaceBetween: 15,
                  },

                  1200: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                  },

                }}
              >

                {products.map(
                  (product) => (

                    <SwiperSlide
                      key={product.id}
                    >

                      <ProductCard
                        product={product}
                      />

                    </SwiperSlide>

                  )
                )}

              </Swiper>

            )}

          </div>

        </div>

      </div>

    </section>

  );
}










